import './jobCardStyles.css'
import { Card } from '@atd/rui-base.mui.card'
import { CardContent } from '@atd/rui-base.mui.card-content'
import { CardHeader } from '@atd/rui-base.mui.card-header'
import CleanTooltip from '../lib/cleanTooltip'
import { Collapse } from '@atd/rui-base.mui.collapse'
import Tooltip from '@mui/material/Tooltip'
import { CARD_SX } from '../ravenV5Theme'

import * as workorderActions from './workorderActions'

import {getJobStatus, jobStates} from './jobStatus'

import { CircularProgress } from '@atd/rui-base.mui.circular-progress'
import CloseIcon from '@mui/icons-material/AddBox'
import DispatchDialog from './dispatch/dispatchDialog'
import { Icon } from '@atd/rui-base.mui.icon'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import OpenIcon from '@mui/icons-material/IndeterminateCheckBox'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { getFieldAnalyzerLabel } from './fieldAnalyzerLabel'

function mapStateToProps(state, ownProps) {
    const wo = state.workorder.workorders.find((wo) => {
        return wo.guid == ownProps.guid
    }) || {}
    if (!wo.metadata) wo.metadata = {}

    return {
        mixes: wo.metadata.mixes || [],
        rxFiles: wo.metadata.rxFiles || [],
        workorder: wo,
        grower: wo.metadata.grower || {name: 'No Grower'},
        farm: wo.metadata.farm || {name: 'No Farm'},
        field: wo.metadata.field || {name: 'No Field'},
        currentProducts: wo.metadata.products || [],
        createdTimestamp: format(new Date(wo.createdTime), 'P p'),
        completedTimestamp: wo.completedTime ? format(new Date(wo.completedTime), 'P p') : null,
        boundaryPoints: wo.metadata.boundaryPoints || null,
        centroid: wo.metadata.centroid || null,
        entrancePoints: wo.metadata.entrancePoints || null,
        participants: wo.participants || [],
        isThirdParty: !!wo.isThirdParty,
        fieldAnalyzerOperationType: wo.fieldAnalyzerOperationType || null,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(workorderActions, dispatch),
    }
}

class JobCard extends React.Component {
    static defaultProps = {
        name: '',
        guid: '',
    }

    constructor(props) {
        super(props)
        this.state = {
            dispatchOpen: false,
            touched: false,
            fetchingFiles: false,
            jobReportEnabled: false,
            expanded: false,
            productsExpanded: false,
            participantsExpanded: false,
        }
    }

    toggleExpanded = () => {
        this.setState({expanded: !this.state.expanded})
    }
    toggleProductsExpanded = (e) => {
        if (e) { e.stopPropagation() }
        this.setState({productsExpanded: !this.state.productsExpanded})
    }
    toggleParticipantsExpanded = (e) => {
        if (e) { e.stopPropagation() }
        this.setState({participantsExpanded: !this.state.participantsExpanded})
    }

    changeArchiveStatus = () => {
        this.props.setWorkorderArchived(this.props.workorder.id, !this.props.workorder.archived)
    }
    dispatchRequested = () => {
        this.setState({dispatchOpen: true})
    }
    handleClose = () => {
        this.setState({dispatchOpen: false})
    }
    isAsAppliedJob = () => {
        return !this.props.workorder.cloudJob &&
            (this.props.workorder.originationId == 'FC' || this.props.workorder.originationId == 'USB')
    }

    loadJobFiles() {
        if (!this.state.touched) {
            this.setState({ touched: true, fetchingFiles: true })
            this.props
                .loadWorkorderApplicationFiles(this.props.workorder.id)
                .then((files) => {
                    this.setState({
                        fetchingFiles: false,
                        jobReportEnabled: files.length > 0,
                    })
                })
        }
    }

    renderProducts = () => {
        let products
        if (!this.props.currentProducts.length) {
            products = <span>No Products</span>
        }
        else {
            products = (
                <table style={{width: '100%'}}>
                    <tbody>
                        {this.props.currentProducts.map(this.renderProductLine)}
                    </tbody>
                </table>
            )
        }

        const isExpandable = !!this.props.currentProducts.length

        return (
            <Card sx={{...CARD_SX, marginBottom: '5px'}}>
                <CardHeader
                    sx={{
                        backgroundColor: isExpandable ? 'var(--primary)' : '#EEEEEE',
                        cursor: isExpandable ? 'pointer' : 'default',
                    }}
                    titleTypographyProps={{style: {fontSize: '15px', color: isExpandable ? 'white' : 'black'}}}
                    title={`Products (${this.props.currentProducts.length})`}
                    onClick={isExpandable ? this.toggleProductsExpanded : undefined}
                    action={isExpandable ? (
                        <IconButton onClick={this.toggleProductsExpanded} size="small">
                            {this.state.productsExpanded ? <OpenIcon htmlColor="white"/> : <CloseIcon htmlColor="white"/>}
                        </IconButton>
                    ) : undefined}
                />
                <Collapse in={isExpandable && this.state.productsExpanded}>
                    <CardContent>
                        {products}
                    </CardContent>
                </Collapse>
            </Card>
        )
    }
    renderProductLine = (data, i) => {
        let rateLabel
        if (data.rxMapColumnId) {
            rateLabel = '(Rx Map)'
        }
        else {
            rateLabel = `(${data.displayRate} ${data.userDisplayUnit})`
        }

        return (
            <tr key={`${data.id}-${i}`}>
                <td>{ data.mix ? data.mix.name : 'N/A'}</td>
                <td>{rateLabel}</td>
            </tr>
        )
    }
    renderParticipants = () => {
        let participants
        if (!this.props.participants.length) {
            participants = <span>No Participants</span>
        }
        else {
            participants = (
                <table style={{width: '100%'}}>
                    <tbody>
                        {this.props.participants.map(this.renderParticipantLine)}
                    </tbody>
                </table>
            )
        }

        const isExpandable = !!this.props.participants.length

        return (
            <Card sx={{...CARD_SX, marginBottom: '5px'}}>
                <CardHeader
                    sx={{
                        backgroundColor: isExpandable ? 'var(--primary)' : '#EEEEEE',
                        cursor: isExpandable ? 'pointer' : 'default',
                    }}
                    titleTypographyProps={{style: {fontSize: '15px', color: isExpandable ? 'white' : 'black'}}}
                    title={`Participants (${this.props.participants.length})`}
                    onClick={isExpandable ? this.toggleParticipantsExpanded : undefined}
                    action={isExpandable ? (
                        <IconButton onClick={this.toggleParticipantsExpanded} size="small">
                            {this.state.participantsExpanded ? <OpenIcon htmlColor="white"/> : <CloseIcon htmlColor="white"/>}
                        </IconButton>
                    ) : undefined}
                />
                <Collapse in={isExpandable && this.state.participantsExpanded}>
                    <CardContent>
                        {participants}
                    </CardContent>
                </Collapse>
            </Card>
        )
    }
    renderParticipantLine = (data, i) => {
        return (
            <tr key={data.id}>
                <td>{data.name || data.id || 'N/A'}</td>
                <td>{data.status}</td>
            </tr>
        )
    }
    renderLiveButton = () => {
        const machineViewDomain = window.location.hostname.includes('.ravenslingshot') ? `https://apps.ravenslingshot.com` : `https://apps.raven.engineering`
        const liveJobLink = `${machineViewDomain}/MachineView?liveJobGuid=${this.props.workorder.guid}`

        if (!this.props.workorder.archived && this.props.workorder.cloudJob) {
            return (
                <CleanTooltip title="Go To Live Job">
                    <IconButton href={liveJobLink} size="large">
                        <Icon sx={{ lineHeight: 'normal' }}>
                            <img src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_LiveView.svg`}/>
                        </Icon>
                    </IconButton>
                </CleanTooltip>
            )
        }
    }
    renderDispatchButton = () => {
        // only dispatch non-archived pre-populated jobs & cloud jobs (not as applied-jobs)
        if (!this.props.workorder.archived && !this.isAsAppliedJob()) {
            const dispatcher = this.renderDispatcher()
            const isUnreleased = this.props.workorder.releasedTime == null || new Date(this.props.workorder.releasedTime) > new Date()

            const button = (
                <IconButton
                    onClick={this.dispatchRequested}
                    disabled={isUnreleased}
                    size="large"
                    style={isUnreleased ? {pointerEvents: 'none'} : undefined}
                >
                    <Icon sx={{ lineHeight: 'normal' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_BtnDispatch.svg`}
                            style={isUnreleased ? {filter: 'grayscale(100%)', opacity: 0.45} : undefined}
                        />
                    </Icon>
                    {dispatcher}
                </IconButton>
            )

            if (isUnreleased) {
                return (
                    <Tooltip title="Unreleased jobs cannot be dispatched">
                        <span style={{display: 'inline-flex'}}>
                            {button}
                        </span>
                    </Tooltip>
                )
            }

            return (
                <CleanTooltip title="Dispatch">
                    {button}
                </CleanTooltip>
            )
        }
    }
    renderDetailsButton = () => {
        // only show details for pre-populated jobs & cloud jobs (not as applied-jobs)
        if (!this.isAsAppliedJob()) {
            return (
                <CleanTooltip title="Details">
                    <IconButton href={`/jobs/details/${this.props.workorder.id}`} size="large">
                        <Icon sx={{ lineHeight: 'normal' }}>
                            <img src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_BtnDetails.svg`}/>
                        </Icon>
                    </IconButton>
                </CleanTooltip>
            )
        }
    }
    renderOpenReportButton = () => {
        return (
            <React.Fragment>
                {this.state.fetchingFiles && <CircularProgress size={24} style={{ marginLeft: '10px'}} sx={{color: 'var(--primary)'}} />}
                {!this.state.fetchingFiles && this.state.jobReportEnabled && (
                    <CleanTooltip title="Go to Job Report">
                        <IconButton
                            href={`/jobs/applicationreport/${this.props.workorder.guid}`}
                            size="large"
                        >
                            <Icon sx={{ lineHeight: 'normal' }}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_ViewReport.svg`}
                                />
                            </Icon>
                        </IconButton>
                    </CleanTooltip>
                )}
                {!this.state.fetchingFiles && !this.state.jobReportEnabled && (
                    <CleanTooltip title="Job Report Unavailable">
                        <IconButton
                            disableTouchRipple
                            style={{ cursor: 'default' }}
                            size="large"
                        >
                            <Icon sx={{ lineHeight: 'normal' }}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_ViewReportDisabled.svg`}
                                />
                            </Icon>
                        </IconButton>
                    </CleanTooltip>
                )}
            </React.Fragment>
        )
    }
    renderDispatcher = () => {
        if (this.state.dispatchOpen) {
            return <DispatchDialog
                guid={this.props.guid}
                open={true}
                onClose={this.handleClose}
                onDispatch={this.handleClose}
                boundaryPoints={this.props.boundaryPoints}
                entrancePoints={this.props.entrancePoints}
                centroid={this.props.centroid}
                isThirdPartyWorkorder={this.props.isThirdParty}
            />
        }
    }
    getInfoIcons() {
        const hasHeaderBadges = this.hasHeaderBadges()
        const icons = []
        const statusIcon = this.getJobStatusIcon()
        if (statusIcon) {
            icons.push(statusIcon)
        }
        if (this.props.workorder.originationId === 'PORTAL' || this.props.workorder.originationId === 'API') {
            icons.push(
                <CleanTooltip title="Pre-Populated Job" key={`ppj-${this.props.workorder.id}`}>
                    <img src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_StatusPPJob.svg`}
                        style={{height: '30px', width: '30px'}}
                    />
                </CleanTooltip>)
        }
        if (this.props.workorder.cloudJob) {
            icons.push(
                <CleanTooltip title="Cloud Job" key={`cloudStatus-${this.props.workorder.id}`}>
                    <img src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_StatusCloudJob.svg`}
                        style={{height: '30px', width: '30px'}}
                    />
                </CleanTooltip>)
        }

        return (
            <div className={`statusIcons ${hasHeaderBadges ? 'statusIconsWithBadges' : ''}`}>
                <div className="statusIconsRow">
                    {icons}
                </div>
                {this.props.isThirdParty && <span className="thirdPartyBadge thirdPartyBadgeHeader">3rd Party</span>}
                {this.renderFieldAnalyzerBadge()}
            </div>
        )
    }
    hasFieldAnalyzerBadge() {
        return !!getFieldAnalyzerLabel(this.props.fieldAnalyzerOperationType)
    }
    hasHeaderBadges() {
        return this.props.isThirdParty || this.hasFieldAnalyzerBadge()
    }
    renderFieldAnalyzerBadge() {
        const label = getFieldAnalyzerLabel(this.props.fieldAnalyzerOperationType)
        if (!label) return null

        return (
            <span
                className="fieldAnalyzerBadge"
                aria-label={label}
            >
                {label}
            </span>
        )
    }
    getBackgroundColor() {
        switch (getJobStatus(this.props.workorder)) {
            case jobStates.ARCHIVED: return '#DDDDDC'
            case jobStates.IN_PROGRESS: return '#d6e4f8'
            case jobStates.NEW_JOB:
            case jobStates.INACTIVE:
            default: return 'white'
        }
    }
    getJobStatusIcon() {
        const status = getJobStatus(this.props.workorder)
        let iconString
        switch (status) {
            case jobStates.ARCHIVED:
                iconString = 'Archived'
                break
            case jobStates.IN_PROGRESS:
                iconString = 'Active'
                break
            case jobStates.NEW_JOB:
                iconString = 'New'
                break
            case jobStates.INACTIVE:
            default:
                iconString = null
                break
        }
        if (iconString) {
            return (
                <CleanTooltip title={iconString + ' Job'} key={`jobStatus-${this.props.workorder.id}`}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_Status${iconString}.svg`}
                        style={{height: '30px', width: '30px'}}
                    />
                </CleanTooltip>
            )
        }
    }
    render() {
        return (
            <div className="jobCard" name={this.props.workorder.id} onClick={() => this.loadJobFiles()}>
                <Card className="jobCardContainer" sx={{...CARD_SX, backgroundColor: this.getBackgroundColor()}}>
                    <CardHeader
                        title={`${this.props.workorder.name}`}
                        titleTypographyProps={{sx: {paddingRight: '25px', fontSize: '15px'}}}
                        onClick={this.toggleExpanded}
                        sx={{cursor: 'pointer'}}
                        className={`cardHeader ${this.hasHeaderBadges() ? 'cardHeaderWithBadges' : ''}`}
                        subheader={(
                            <React.Fragment>
                                <table style={{ borderCollapse: 'collapse' }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <CleanTooltip title="When the job record was created.">
                                                    <div className="cardSubtitle" name="createdTimestampLabel">Created: </div>
                                                </CleanTooltip>
                                            </td>
                                            <td>
                                                <div className="cardSubtitle" name="createdTimestampValue">{this.props.createdTimestamp}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <CleanTooltip title="The session end time of the session the job was marked completed in.">
                                                    <div className="cardSubtitle" name="completedTimestampLabel">Completed:&nbsp;&nbsp;</div>
                                                </CleanTooltip>
                                            </td>
                                            <td>
                                                <div className="cardSubtitle" name="completedTimestampValue">{this.props.completedTimestamp}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className={`cardSubtitle ${this.hasHeaderBadges() ? 'gffInfoWithBadges' : ''}`} name="gffInfo">
                                    {`${this.props.grower.name} > ${this.props.farm.name} > ${this.props.field.name}`}
                                </div>
                                {this.getInfoIcons()}
                            </React.Fragment>
                        )}
                    />
                    <Collapse in={this.state.expanded}>
                        <CardContent name="jobInfo" sx={{paddingBottom: 0, '&:last-child': {paddingBottom: 0}}}>
                            {this.renderProducts()}
                            {this.renderParticipants()}
                            <div className="jobCardActionBar">
                                <div className="jobCardButtons">
                                    {this.renderLiveButton()}
                                    {this.renderDispatchButton()}
                                    {this.renderDetailsButton()}
                                    <CleanTooltip title={this.props.workorder.archived ? 'Unarchive' : 'Archive'}>
                                        <IconButton
                                            onClick={this.changeArchiveStatus}
                                            name="archiveButton"
                                            size="large"
                                        >
                                            <Icon sx={{ lineHeight: 'normal' }}>
                                                <img src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_Btn${this.props.workorder.archived ? 'Unarchive' : 'Archive'}Job.svg`}/>
                                            </Icon>
                                        </IconButton>
                                    </CleanTooltip>
                                    {this.renderOpenReportButton()}
                                </div>
                            </div>
                        </CardContent>
                    </Collapse>
                </Card>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobCard)
